module.exports = __webpack_public_path__ + "static/media/ego-threat.e9d75221.svg";